module.exports = __webpack_public_path__ + "static/media/lv_ru_desk_r.a9191bb2.png";